function checkAbility(role) {
  return ["ADMIN", "SUPERADMIN", "SUPER"].includes(role);
}
export default {
  checkAbility
};
